class ProductPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.compare_price = this.querySelector('.product-price--compare'), this.price = this.querySelector('.product-price--original'), this.reference_unit = this.querySelector('.product-price--reference-unit'), this.reference_value = this.querySelector('.product-price--reference-value'), this.unit_price = this.querySelector('.product-price--unit-price'), this.unit_price_container = this.querySelector('.product-price--unit-container'), this.updatePriceListener();
  }

  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
  }

  updatePriceListener() {
    window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({detail: {variant: e}}) => {
      this.updatePrices(e);
    });
  }

  updatePrices(e) {
    if (e) {
      this.removeAttribute('style');
      this.price.innerHTML = theme.utils.formatMoney(e.price);

      if (e.compare_at_price > e.price) {
        this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price);
        this.compare_price.style.display = 'inline-block';

        // Calculate savings and update .h420-product-price--savings span
        const savings = e.compare_at_price - e.price;
        const savingsElement = this.querySelector('.h420-product-price--savings span');
        if (savingsElement) {
          savingsElement.innerHTML = theme.utils.formatMoney(savings);
        }

      } else {
        this.compare_price.style.display = 'none';
        // Optionally hide or reset the savings display if there are no savings
        const savingsElement = this.querySelector('.h420-product-price--savings span');
        if (savingsElement) {
          savingsElement.innerHTML = ''; // Or any default text you'd prefer
        }
      }

      if (e.unit_price_measurement) {
        this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price);
        this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit;

        if (1 === e.unit_price_measurement.reference_value && this.reference_value) {
          this.reference_value.style.display = 'none';
        } else if (this.reference_value) {
          this.reference_value.innerHTML = e.unit_price_measurement.reference_value;
          this.reference_value.style.display = 'block';
        }

        this.unit_price_container.style.display = 'flex';
      } else {
        this.unit_price_container.style.display = 'none';
      }
    } else {
      this.style.display = 'none';
    }
  }
}

const productPriceEl = customElements.get('product-price-root');
productPriceEl || customElements.define('product-price-root', ProductPrice);
